<script lang="ts">
  import DecisionModal from "@retailer/svelte/LimitedOrderingProductRequests/DecisionModal.svelte";
  import Empty from "@retailer/svelte/LimitedOrderingProductRequests/Empty.svelte";
  import LoadingSpinner from "@shared/svelte/Components/LoadingSpinner.svelte";
  import Table from "@retailer/svelte/LimitedOrderingProductRequests/Pending/Table.svelte";
  import RequestNoteModal from "@retailer/svelte/LimitedOrderingProductRequests/RequestNoteModal.svelte";

  import ProductApprovalStore from "@shared/svelte/Stores/ProductApprovalStore";
  import LayoutStore from "@shared/svelte/Stores/LayoutStore";

  import { onMount } from "svelte";
  import { params, goto } from "@roxi/routify";
  import {
    SortOptions,
    sortRequests,
    getLimitedOrderingProductsRes,
  } from "@retailer/services/limited_ordering_product_requests_service";

  import { pluralize } from "@shared/svelte/Modules/pluralize";

  import type { DecisionModalType } from "@retailer/svelte/LimitedOrderingProductRequests/DecisionModal.svelte";

  let requestToDecideOn = null;

  let requestWithNote = null;
  let selectedRetailer = $ProductApprovalStore.retailers.find(
    retailer => retailer.id == $params.retailer,
  )?.id;
  let selectedSortOption = SortOptions[0].value;
  let showLimitedOrderingRequestNoteModal: boolean = false;
  let showLimitedOrderingDecisionModal: boolean = false;
  let modalType: DecisionModalType;
  let loading: boolean = true;

  const updateRequests = (e) => {
    const selectedSortOption = e.currentTarget.value;
    ProductApprovalStore.update(store => {
      store.productRequests = sortRequests(store.productRequests, selectedSortOption);
      return store;
    });
  };

  const openRequestNoteModal = function (request) {
    requestWithNote = request.detail;
    showLimitedOrderingRequestNoteModal = true;
  };

  const openDecisionModal = function (data) {
    requestToDecideOn = data.detail.productRequest;
    showLimitedOrderingDecisionModal = true;
    modalType = data.detail.modalAction;
  };

  const closeModals = function () {
    showLimitedOrderingDecisionModal = false;
    showLimitedOrderingRequestNoteModal = false;
  };

  const selectRetailer = async (e: Event & { currentTarget: HTMLSelectElement }): Promise<void> => {
    loading = true;
    const retailerId: string = e.currentTarget.value;
    const params = retailerId ? { retailer: retailerId } : {};

    $goto(`/product_approvals`, params);
    await getLimitedOrderingProductsRes({
      retailer_id: Number(retailerId),
    });
    loading = false;
  };

  onMount(async () => {
    await getLimitedOrderingProductsRes({ retailer_id: $params.retailer });
    loading = false;
  });
</script>

<div
  class="fizz-flex-row-responsive {$LayoutStore.isMobile
    ? 'fizz-inset-square-16'
    : 'fizz-space-between fizz-inset-vertical-24 fizz-inset-horizontal-32'}"
>
  <div class="fizz-flex-row-responsive">
    <select
      class="fizz-select fizz-text-strong fizz-text-brand"
      name="product_approvals_retailer_select"
      id="product_approvals_retailer_select"
      bind:value={selectedRetailer}
      on:change={selectRetailer}
    >
      <option value="">All retail locations</option>
      {#each $ProductApprovalStore.retailers as retailer (retailer.id)}
        <option value={retailer.id}>{retailer.name}</option>
      {/each}
    </select>
    {#if $ProductApprovalStore.productRequests.length}
      <div class="fizz-text-medium fizz-text-subdued">
        Showing {pluralize("product", $ProductApprovalStore.productRequests.length, true)}
      </div>
    {/if}
  </div>
  <div>
    <select
      class="fizz-select fizz-text-brand"
      style={$LayoutStore.isMobile ? "width: 100%" : ""}
      name="request_sort_select"
      id="request_sort_select"
      bind:value={selectedSortOption}
      on:change={updateRequests}
    >
      {#each SortOptions as option (option.value)}
        <option value={option.value}>
          {selectedSortOption === option.value ? "Sort by: " : ""}{option.label}
        </option>
      {/each}
    </select>
  </div>
</div>
{#if loading}
  <LoadingSpinner />
{:else if $ProductApprovalStore.productRequests.length}
  <Table on:openDecisionModal={openDecisionModal} on:openRequestNoteModal={openRequestNoteModal} />
{:else}
  <Empty />
{/if}

<RequestNoteModal
  bind:request={requestWithNote}
  show={showLimitedOrderingRequestNoteModal}
  onClose={closeModals}
/>

<DecisionModal
  bind:request={requestToDecideOn}
  show={showLimitedOrderingDecisionModal}
  onClose={closeModals}
  {modalType}
/>
